<template>
  
    
    <div class="homePrincipal">
      <p class="usuario"> Bienvenid@:  {{ this.email2 }}</p>
      <div class="tiraNegra">
        <!--h1 class="title text-center titulo">REPORTES PERSONALIZADOS</h1-->
      </div>
      <div class="row justify-content-center" >

        <!--<vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>-->
      
        <!--<button class="btn btn-sm btn-primary mt-3"  @click="generarReporte()">Kilometraje</button>
        <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Entradas y salidas</button>
        <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Telemetrias</button>
        <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Disponibilidad</button>
        <router-link to="/kilometros">
        <span class="btn btn-sm mt-3 outline-primary" variant="outline-primary" style="margin: 10px">
          <div class="h3 mb-0">
            <b-icon-clock-history></b-icon-clock-history>
          </div>
          Kilometros 
        </span>
      </router-link>
        
        -->
        <router-link to="/kilometros" class="router-link">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/kilometros.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Kilometros</h3>     
      </router-link> 
      <router-link to="/kilometrosOP" class="router-link">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/kilometrosop.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Kilometros OP</h3>     
      </router-link>
      <router-link to="/sitios" class="router-link">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/sitios.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Sitios</h3>     
      </router-link> 
      
      <router-link to="/gruposSitios">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/grupodesitios.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Tipo de Sitios</h3> 
        </router-link>
      <router-link to="/historicoSitios">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/Historico.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Historico Sitios</h3>
      </router-link>
      <router-link to="/telemetrias">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/telemetrias.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Telemetrias</h3>
      </router-link>
      <router-link to="/cansancio">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/cansancio.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Cansancio</h3>
      </router-link>
      
      <router-link to="/disponibilidad">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/disponibilidad.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Disponibilidad</h3>
        </router-link>
       <!-- <router-link to="/asistencia">
          <b-button variant="outline-success" style="margin: 10px">
          <div class="h3 mb-0">
            <b-icon-list></b-icon-list>
          </div>
          Asistencia
        </b-button>
        </router-link>-->
        <router-link to="/lectoras">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/lectorasconteos.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Lectoras Conteo</h3>
        </router-link>
        <router-link to="/registrosLectoras">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/lectorasdatos.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Lectoras Datos</h3>
        </router-link>
        <!-- <router-link to="/registrosLectorasrfid">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/lectorasdatos.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Lectoras Datos Rfid</h3>
        </router-link>-->
        <!--<router-link to="/fallas">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h3 mb-0">
            <b-icon-gear></b-icon-gear>
          </div>
          Fallas
        </b-button>
        </router-link>-->
        <router-link to="/PmotorBpanico">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/parodemotor.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Paro Motor, Boton <br> Panico y Cámaras</h3>
        </router-link>
       <!--  <router-link to="/operadores">
       <b-button variant="outline-success" style="margin: 10px">
          <div class="h3 mb-0">
            <b-icon-person-lines-fill></b-icon-person-lines-fill>
          </div>
          Operadores
        </b-button>
        </router-link>-->

        <router-link to="/contadorLectoras">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/unidadeslectoras.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Contador Unidades <br>Lectoras</h3>
        </router-link>
        <!--</span>-->

        <router-link to="/FallaElectricaGPS">
          <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/fallaelectrica.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Fallas Eléctricas Gps</h3>
        </router-link>
         <!--</span>-->
      
      <router-link to="/UnidadSinReportar">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/unidadsinreportar.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Unidad sin reportar</h3>
        </router-link>

        <router-link to="/UnidadEnTaller">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/disponibilidad.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Unidades en Taller</h3>
        </router-link>
        <router-link to="/TicketSalidasTaller">
        <div class="carta">
          <div class="face front" >
              <img class="imagen" src="../../public/images/img/camioncitosalida.png" alt="" id="enlace">
          </div>
        </div>
          <h3 class="texto">Ticket Salidas Taller</h3>
        </router-link>
    
                

      </div>
      <!--div align="right">{{email2}}</div-->
     
      
      
      
      

    </div>
    
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
 
   // props: {
   // email: {
   //   type: String
   // }
  //},
  data() {
     
       
       
    return {
      email2: sessionStorage.email
    }
  },

  computed: {
    ...mapState({
    }),

    ...mapState(["cargando"]),

  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),
  },
  //mounted() {
  //  if (localStorage.aleatorio) {
  //    this.aleatorio = localStorage.aleatorio;
  //  }
  //},
  //watch: {
  //  aleatorio(newEmail) {
  //    localStorage.aleatorio = newEmail;
  //  }
  //}
  mounted(){
  if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
    
  
  }
  
   // this.$router.push({name: "sitios" });
  
},
}

</script>
<style>
/* Works on Firefox */
* {
  
  scrollbar-width: thin;
  scrollbar-color: #336699 rgba(255, 255, 255, 0.7);
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  display: none;
  width: 12px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.7);
}

*::-webkit-scrollbar-thumb {
  background-color: #336699;
  border-radius: 40px;
  border: 1px solid rgba(255, 255, 255, 0.7);
}



  .homePrincipal{
    margin-top: 2.5%;
    margin-right: 1%;
    margin-left: 1%;
    margin-bottom:1%;
  }
  .tiraNegra{
    background-image: url(../../public/images/img/super.png);
    background-repeat: no-repeat;
    background-size: 80%;
    height:90px;
    width: 100%;
    position: relative;
    display:inline-block;
    border-radius: 3px;
    float:left;
    left:25%;
    margin-bottom: 20px;
  }
  .usuario{
    position: absolute;
    top: 60px;
    left:10%;
    font-size: 18px;
    color:white;
    text-align: left;
    margin-left: 0px;
    margin-bottom:0px;
  }
  .titulo{
    position: absolute;
    top: 10px;
    left: 30%;
    font-size: 40px;
    color:#020135;
    font-weight: bold;
  }
  .texto{
    text-align: center;
    text-decoration: none;
    font-size: 20px;
    color:white;
    margin-top:10px;
    word-wrap: break-word;
  }
  
  .carta{
    position: relative;
    display:inline-block;
    background-color: #000;
    border-radius: 1rem;
    margin: 20px;
    opacity: .9;
  }
  .carta .front:hover {
    text-decoration: none;
    filter: brightness(1.80);
    transition: .5s;
    color: #F5B142;
  }

  .imagen{
    border-radius: .3rem;
  }
  .cuadroOPciones{
    margin: 0;
  }
</style>